import React from "react";
import {
  Box,
  Card,
  CardBody,
  Heading,
  Switch,
  FormControl,
  FormLabel,
  NumberInput,
  NumberInputField,
  Stack,
  Divider,
  Text,
} from "@chakra-ui/react";

const AIFollowUps = () => {
  const [settings, setSettings] = React.useState({
    emailFollowUp: true,
    emailDelay: 24,
    smsReminder: false,
    whatsappNotification: false,
  });

  const handleSettingChange = (setting) => (value) => {
    setSettings({
      ...settings,
      [setting]: setting.includes("Delay") ? value : value,
    });
  };

  return (
    <Box p={3}>
      <Heading as="h4" size="lg" mb={3}>
        AI-Based Follow-Ups
      </Heading>

      <Card>
        <CardBody>
          <Stack spacing={3}>
            <Heading as="h6" size="md" color="blue.500">
              Automated Follow-up Settings
            </Heading>

            <FormControl display="flex" alignItems="center">
              <Switch
                isChecked={settings.emailFollowUp}
                onChange={(e) =>
                  handleSettingChange("emailFollowUp")(e.target.checked)
                }
                mr={3}
              />
              <FormLabel mb={0}>Enable Email Follow-ups</FormLabel>
            </FormControl>

            {settings.emailFollowUp && (
              <FormControl maxW="200px">
                <FormLabel>Follow-up Delay (hours)</FormLabel>
                <NumberInput
                  value={settings.emailDelay}
                  onChange={(value) => handleSettingChange("emailDelay")(value)}
                  min={1}
                  max={168}
                >
                  <NumberInputField />
                </NumberInput>
                <Text fontSize="sm" color="gray.500">
                  How many hours to wait before sending a follow-up
                </Text>
              </FormControl>
            )}

            <Divider />

            <FormControl display="flex" alignItems="center">
              <Switch
                isChecked={settings.smsReminder}
                onChange={(e) =>
                  handleSettingChange("smsReminder")(e.target.checked)
                }
                mr={3}
              />
              <FormLabel mb={0}>Enable SMS Reminders</FormLabel>
            </FormControl>

            <FormControl display="flex" alignItems="center">
              <Switch
                isChecked={settings.whatsappNotification}
                onChange={(e) =>
                  handleSettingChange("whatsappNotification")(e.target.checked)
                }
                mr={3}
              />
              <FormLabel mb={0}>Enable WhatsApp Notifications</FormLabel>
            </FormControl>

            <Text fontSize="sm" color="gray.500">
              The system will automatically send follow-ups using different
              channels if recipients don't open your emails. Subject lines will
              be dynamically optimized to increase open rates.
            </Text>
          </Stack>
        </CardBody>
      </Card>
    </Box>
  );
};

export default AIFollowUps;
